import { Tabs } from "@mantine/core";
import dynamic  from "next/dynamic";

import FanRankEmptyView from "_components/atoms/fanRankEmptyView";
import Typography       from "_components/atoms/typography";
import ChatContainer    from "_components/features/chat/container";
import DonationTab      from "_components/organisms/donationTab";
import FanLeaderboard   from "_components/organisms/fanLeaderboard";

import useStyles from "./styles";

const DonationModals = dynamic ( () => import ( "_components/molecules/donationModals" ) );
const PollsModals    = dynamic ( () => import ( "_components/organisms/pollsModals" ) );

const component = ( {
	theatreModeToggle,
	broadcastId,
	fromStudio = false,
	isStreamer,
	chatPoppedOut,
	closeDonationModals,
	displayModal,
	donationOption,
	errorModal,
	handleModal,
	handleModalOptions,
	broadcasterId,
	toggleErrorModal,
	isFanLeaderboardLive,
	isBlockedByStreamer,
	isSessionEnded,
	leaderboardData,
	pollsEnabled,
	isMobile,
	handleDisabledChatInputClick,
	autoDonationModal,
	previousComments
} ) => {

	const { classes, theme } = useStyles ( { theatreModeToggle, chatPoppedOut } );

	const showFanRank = isFanLeaderboardLive && !isBlockedByStreamer;

	const fanrankTabContent = isFanLeaderboardLive && !isBlockedByStreamer ? (
		<FanLeaderboard
			broadcastId = { broadcastId }
			isSessionEnded = { isSessionEnded }
			leaderboardData = { leaderboardData }
			theatreModeToggle = { theatreModeToggle }
		/>
	)
		: (
			<FanRankEmptyView msg = { isBlockedByStreamer ?
				"Nothing to show here." : isStreamer
					? "Nothing to show here." :
					"Watch this Stream for Longer time to get featured here." }
			/>
		);

	const donationTabContent = (
		<DonationTab
			broadcastId = { broadcastId }
			chatPoppedOut = { chatPoppedOut }
			isBlockedByStreamer = { isBlockedByStreamer }
			isSessionEnded = { isSessionEnded }
		/>
	);

	return (
		<div className = { classes.rightSideBarContainerLive }>
			<Tabs
				key = { broadcastId }
				defaultValue = { "Live Chat" }
				keepMounted = { true }
				styles = { {
					root: {
						width: chatPoppedOut || isMobile ? "100vw" : "25vw"
					},
					list: {
						backgroundColor: theme.other.colors.background.secondary
					},
					panel: {
						background         : theme.other.darkMode ? theme.other.paletteNew.secondaryBlack : theme.other.paletteNew.secondaryWhite,
						height             : ( isMobile && !chatPoppedOut ) ? "50vh" : ( theatreModeToggle || chatPoppedOut ) ? "calc(100vh - 55px)" : "calc( 100vh - 125px )",
						width              : "100%",
						flex               : !isMobile ? "1" : "unset",
						overscrollBehavior : "contain"
					}
				} }
			>
				<Tabs.List
					grow
				>

					<Tabs.Tab
						value = { "Live Chat" }
					>
						<Typography
							className = { classes.tabText }
							title = { "Live Chat" }
						/>
					</Tabs.Tab>

					{showFanRank ? (
						<Tabs.Tab
							value = { "Fan Rank" }
						>
							<Typography
								className = { classes.tabText }
								title = { "Fan Rank" }
							/>
						</Tabs.Tab>
					) : null}

					<Tabs.Tab
						value = { "Donations" }
					>
						<Typography
							className = { classes.tabText }
							title = { "Donations" }
						/>
					</Tabs.Tab>
				</Tabs.List>

				<Tabs.Panel
					value = { "Live Chat" }
				>
					<ChatContainer
						key = { broadcastId }
						broadcastId = { broadcastId }
						chatPoppedOut = { chatPoppedOut }
						closeDonationModals = { closeDonationModals }
						displayModal = { displayModal }
						donationOption = { donationOption }
						errorModal = { errorModal }
						fromStudio = { fromStudio }
						handleDisabledChatInputClick = { handleDisabledChatInputClick }
						handleModal = { handleModal }
						handleModalOptions = { handleModalOptions }
						isFromLayout = { true }
						isMobile = { isMobile }
						isStreamer = { isStreamer }
						leaderboardData = { leaderboardData }
						previousComments = { previousComments }
						theatreModeToggle = { theatreModeToggle }
						toggleErrorModal = { toggleErrorModal }
					/>

					<DonationModals
						autoDonationModal = { autoDonationModal }
						broadcasterId = { broadcasterId }
						broadcastId = { broadcastId }
						closeDonationModals = { closeDonationModals }
						displayModal = { displayModal }
						donationOption = { donationOption }
						errorModal = { errorModal }
						handleModal = { handleModal }
						handleModalOptions = { handleModalOptions }
						toggleErrorModal = { toggleErrorModal }
					/>
				</Tabs.Panel>

				<Tabs.Panel value = { "Fan Rank" }>
					{fanrankTabContent}
				</Tabs.Panel>

				<Tabs.Panel value = { "Donations" }>
					{donationTabContent}
				</Tabs.Panel>

			</Tabs>

			{
				pollsEnabled && !isSessionEnded && (
					<PollsModals
						broadcastId = { broadcastId }
					/>
				)
			}

		</div>
	);
};

export default component;
